<template>
<!-- <div v-on:mousemove="doDrag"> -->
<buyer-dash v-if="user.roleId.id === 18"/>
<marketer-dash v-else-if="user.roleId.id === 14 || user.roleId.id === 20"/>
<warehouse-dash v-else-if="user.roleId.id === 26"/>
<nce-dash v-else-if="user.roleId.id === 15"/>
<coopmaker-dash v-else-if="user.roleId.id === 19"/>
<coopchecker-dash v-else-if="user.roleId.id === 25"/>
<miller-dash v-else-if="user.roleId.id === 28 || user.roleId.id === 29"/>
<kpcu-dash v-else-if="user.roleId.id === 30 || user.roleId.id === 31"/>
<fcs-dash v-else-if="user.roleId.name === 'FCS_MAKER'"/>
<fcsmanager-dash v-else-if="user.roleId.name === 'FCS MANAGER'"/>
<!-- </div> -->
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import config from '../../config'
import BuyerDash from '../dashboards/BuyerDash'
import MarketerDash from '../dashboards/MarketerDash'
import WarehouseDash from '../dashboards/WarehouseDash'
import NceDash from '../dashboards/NCEDash'
import CoopmakerDash from '../dashboards/CoopMakerDash'
import CoopcheckerDash from '../dashboards/CoopcheckerDash'
import MillerDash from '../dashboards/MillerDash'
import KpcuDash from '../dashboards/KPCUDash'
import FcsDash from '../dashboards/FCSDash'
import FcsmanagerDash from '../dashboards/FCSManagerDash'

export default {
  name: 'dashboard',
  components: {
    BuyerDash,
    MarketerDash,
    WarehouseDash,
    NceDash,
    CoopmakerDash,
    CoopcheckerDash,
    MillerDash,
    KpcuDash,
    FcsDash,
    FcsmanagerDash
  },
  data () {
    return {
      idleTime: 0,
      interval: '',
      x: 0,
      y: 0
    }
  },
  computed: {
    ...mapState([
      'userInfo', 'user'
    ]),
    roleId: function () {
      // 1 SUPER_ADMIN
      // 14  MARKETER_CHECKER
      // 15  NCE_USER
      // 18  BUYER
      // 19  BANKER_MAKER
      // 20  MARKETER_MAKER
      // 21  COOP_ADMIN
      // 22  HELPDESK
      // 23  SYSTEM_ADMIN
      // 24  KENGLOBAL
      // 25  BANKER_CHECKER
      // 26  WAREHOUSE
      // 28  MILLER
      if (this.user) {
        return this.user.roleId.id
      }
      return 0
    }
  },
  mounted () {
    // this.interval = setInterval(this.increaseIdleTime, 60000)
    this.onResize()
  },
  watch: {
  },
  methods: {
    onResize () {
      this.x = window.innerWidth
      this.y = window.innerHeight
    },
    doDrag () {
      if (this.idleTime > 0) {
        this.idleTime = 0
        console.log('idle time reset')
      }
    },
    increaseIdleTime () {
      this.idleTime++
      console.log(this.idleTime)
      if (this.idleTime > config.sessionTimeout) {
        console.log('logging out user')
        this.logout()
      }
    },
    logout () {
      const url = config.serverURI + '/token/logout'
      axios.post(url, this.user)
        .then(response => {
          this.message = response.data.message
          this.$store.commit('SET_USER', null)
          this.$store.commit('SET_TOKEN', null)
          if (window.localStorage) {
            window.localStorage.setItem('user', null)
            window.localStorage.setItem('token', null)
          }
          this.$router.push('/login')
          // clear the timer
          clearInterval(this.interval)
        })
        .catch(error => {
          console.log('error', error.response)
        })
    }
  }
}
</script>
<style>
</style>
